import React from 'react'
import { BrowserRouter, Route, Routes, Link } from 'react-router-dom';
import { useState } from 'react'
import { Layout, Menu, Divider } from 'antd';
import {
  HomeOutlined,
  ControlOutlined
} from '@ant-design/icons';
import logo from './assets/images/logo.png';
import './App.css';
import Home from './containers/Home/Home';
import Manage from './containers/Manage/Manage';

const { Header, Content, Footer, Sider } = Layout;

function App() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <BrowserRouter>
      <Layout styles={{minHeight: '100vh'}}>
        <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed} width={200}>
          <div className="logo">
            <img src={logo} alt="Harbour Master" width="200" />
          </div>
          <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
            <Menu.Item key="1" icon={<HomeOutlined />}>
              <Link to="/">Home</Link>
            </Menu.Item>
            <Menu.Item key="2" icon={<ControlOutlined />}>
              <Link to="/manage">Manage</Link>
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout style={{minHeight: '100vh' }}>
          <Header style={{minHeight: '10vh' }}>
            <h1 className="custom-header">Harbour Master</h1>
          </Header>
          <Content>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/manage" element={<Manage />} />
            </Routes>
          </Content>
          <Footer className="custom-footer"><Divider orientation="center" orientationMargin="150">By Jody Swartz</Divider></Footer>
        </Layout>
      </Layout>
    </BrowserRouter>
  );
}


export default App;